export interface IAcceptanceCodeableConcept {
    coding: number;
    text: string;
}